import axios from 'axios'
import { useState } from 'react'
import {Modal} from 'react-bootstrap'

const AddNewAlert = ({show, setShow, formData, action, setFormData, setNotification, setReRender}) => {
    const [loader, setLoader] = useState(false);

    const handlers = {
        addNewAlert(e){
            e.preventDefault();
            setLoader(true);
            axios.post('/api/extension/v1/alerts', formData)
                .then((res) => {
                    setNotification({show: true, type: "success", text: res.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                    setShow((prev) => ({...prev, createAlert: false}));
                    setReRender((prev) => prev + 1)
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                })
        },
        editAlert(e){
            e.preventDefault();
            setLoader(true);
            axios.put(`/api/extension/v1/alerts/${formData.id}`, formData)
                .then((res) => {
                    setNotification({show: true, type: "success", text: res.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                    setShow((prev) => ({...prev, createAlert: false}));
                    setReRender((prev) => prev + 1)
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                })
        }
    }

    return(
        <Modal show={show} onHide={() => setShow((prev) => ({...prev, createAlert: false}))} size='lg' centered>
            <Modal.Header closeButton><h2 className="modal-title-text">Add New Alert</h2></Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <form className='row' onSubmit={handlers[action == "add" ? "addNewAlert" : "editAlert"]}>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-buyer">Title*</label>
                                <input id="form-buyer" required placeholder="Enter alert title" type="text" className="form-control" name="buyer" value={formData.title} onChange={(e) => setFormData((prev) => ({...prev, title: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-auction">Alert type*</label>
                                <select id="form-auction" required className="form-control" name="auction" value={formData.alert_type} onChange={(e) => setFormData((prev) => ({...prev, alert_type: e.target.value}))}>
                                    <option value={""}>Select Alert Type</option>
                                    <option value={"#28a745"}>Success</option>
                                    <option value={"#17a2b8"}>Info</option>
                                    <option value={"#ffc107"}>Warning</option>
                                    <option value={"#dc3545"}>Problem</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-12 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-password">Message*</label>
                                <textarea style={{height: "100px"}} id="form-password" required placeholder="Enter message" type="text" className="form-control" name="password" value={formData.html} onChange={(e) => setFormData((prev) => ({...prev, html: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="modal-action-buttons">
                            <button type="submit" disabled={loader} className="submit-modal-form-btn">{loader ? <div className="button-loader"></div> : (action == "add" ? "Submit" : "Save")}</button>
                            <button type="button" onClick={() => setShow((prev) => ({...prev, createAlert: false}))} className="cancel-modal-form-btn">Cancel</button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewAlert